const $ = jQuery;

const ShowMore = {
  init: () => {
    const filters = document.querySelector(".blog .posts-wrapper");
    if(!filters) return;
    
    const tags = document.querySelectorAll(".post-item"); 
    const html = `<div class="show-wrapper"><div class="container"><p class="btn show-more-btn btn-transparent">Load More</p></div></div>`;
    filters.insertAdjacentHTML("beforeend", html);
    const showMore = document.querySelector(".show-more-btn");
    
    tags.forEach((tag, index) => {
      if (index <= 4) {
        tag.classList.add("active");
      }
    });

    let currentVisibleIndex = 4;

    showMore.addEventListener("click", () => {
      if (showMore.textContent === "Load More") {
        let newLimit = tags.length - 1;
        tags.forEach((tag, index) => {
          if (index <= newLimit) {
            tag.classList.add("active");
          }
        });

        currentVisibleIndex = newLimit;

        if (currentVisibleIndex >= tags.length - 1) {
          showMore.textContent = "Load Less";
        }
      } else {
        tags.forEach((tag, index) => {
          if (index > 4) {
            tag.classList.remove("active");
          }
        });

        currentVisibleIndex = 4;
        showMore.textContent = "Load More";
      }
    });
  },
};

export default ShowMore;
